import React from 'react';
import PropTypes from 'prop-types';
import Details from '@eg/elements/Details';
import { legalConsentProps } from '../../../models/panels';
import { getContactData } from '../../../helpers/formData/privateLiabilityFormData';
import { isLiabilityFlow } from '../../../helpers/formData/formData';
import { SvgKontaktdatenDesUnfallbeteiligten } from '../../../helpers/IconLoader';

const ContactDetails = ({ formData, localePath, className }, { t }) => {
  const data = getContactData(formData);
  const isLiability = isLiabilityFlow(formData);

  return (
    <Details
      iconLeft={SvgKontaktdatenDesUnfallbeteiligten}
      isInitiallyOpen
      summary={t(`${localePath}.contact.title`)}
      className={className}
    >
      <p>
        {t(`${localePath}.contact.content-name`, {
          firstName: data.firstName,
          lastName: data.lastName,
        })}
      </p>
      <p>
        {t(`${localePath}.contact.content-phone`, {
          phone: data.phone,
        })}
      </p>
      <p>
        {t(`${localePath}.contact.content-email`, {
          email: data.email,
        })}
      </p>
      { isLiability && (
        <p>
          {t(`${localePath}.contact.content-address`, {
            address: data.address,
            postCode: data.postCode,
            city: data.city,
          })}
        </p>
      )}
    </Details>
  );
};

ContactDetails.propTypes = legalConsentProps.sectionProps;
ContactDetails.defaultProps = legalConsentProps.sectionDefaults;

ContactDetails.contextTypes = {
  t: PropTypes.func,
};

export default ContactDetails;
